import React, { useEffect, useState, useRef, useCallback } from "react";
import { Table, Button, Space, Divider, Switch, Popconfirm } from "antd";
import "./Catalog.css";
import { useSelector } from "react-redux";
import { getFunctions, httpsCallable } from "firebase/functions";
import { PlusOutlined } from "@ant-design/icons";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../database/firebase";
import { Accordion, Icon, Popup, Button as BS } from "semantic-ui-react";
import { ciclu } from "../utils";
import catalogPrimarFinal from "./catalog_slim_final_primar.docx";
import Docxtemplater from "docxtemplater";
import { renderClassName } from "../utils";
import cataloggimnaziuCoperta from "./catalog_gimnaziu_coperta.docx";
import catalogPrimarCoperta from "./catalog_primar_copera.docx";
import cataloggimnaziuFinal from "./catalog_slim_final.docx";
import catalogLiceuFinal from "./catalog_jarda_final.docx";
import cataloggimnaziuRubrica from "./catalog_slim_rubrica_nou_viva.docx";
import catalogliceuRubrica from "./catalog_slim_rubrica_nou_viva_liceu.docx";
import catalogLiceuCoperta from "./catalog_gimnaziu_coperta_liceu.docx";
import catalogprimarRubrica from "./catalog_slim_rubrica_nou_viva_primar.docx";
import cataloggimnaziuPreg from "./catalog_slim_rubrica_preg.docx";
import { motiveazaAbsente } from "../utils/absente";
import { Alert } from "antd";

import PizZip from "pizzip";
import { saveAs } from "file-saver";
// import template from "./instiintare parinti 2024 completat.docx";

import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";
import { getDataDoc } from "../database";
import { updateDocDatabase } from "../database";
import ModalAddGrade from "./ModalAddGrade";
import { Table as CatalogTabel } from "semantic-ui-react";
import ModalViewGrade from "./ModalViewGrade";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { openSuccesNotification } from "../Components/Notifications/succesNotification";
import {
  calculare_medii,
  calculare_medii_incheire_cursuri,
  calculare_stare_after,
  calculare_stare_before,
  calculeaza_medie_materie,
} from "../utils/calculare_medie";
import { exportExcel } from "./excelexport";
import { openErrorNotification } from "./Notifications/errorNotification";
import { maxHeightIcon } from "@progress/kendo-svg-icons";

function truncateFloat(num, decimals = 2) {
  const numValue = Number(num);
  if (isNaN(numValue)) {
    return num;
  }
  const factor = Math.pow(10, decimals);
  const truncated = Math.floor(numValue * factor) / factor;
  return truncated.toFixed(decimals);
}

function extractDateFromCNP(cnp) {
  if (!cnp) return "";
  cnp = String(cnp);
  if (cnp?.length !== 13 || !/^\d+$/.test(cnp)) {
    return "";
    throw new Error("CNP invalid!");
  }

  // Extrage informațiile din CNP
  const gender = parseInt(cnp.charAt(0), 10); // Prima cifră
  const year = parseInt(cnp.slice(1, 3), 10); // Anul (ultimele două cifre)
  const month = parseInt(cnp.slice(3, 5), 10); // Luna
  const day = parseInt(cnp.slice(5, 7), 10); // Ziua

  // Determină secolul pe baza primei cifre
  let fullYear;
  if (gender === 1 || gender === 2) {
    fullYear = 1900 + year; // Secolul 20
  } else if (gender === 3 || gender === 4) {
    fullYear = 1800 + year; // Secolul 19
  } else if (gender === 5 || gender === 6) {
    fullYear = 2000 + year; // Secolul 21
  } else {
    throw new Error("CNP invalid: prima cifră nu este validă!");
  }

  // Verifică datele extrase
  const isValidDate = (y, m, d) => {
    const date = new Date(y, m - 1, d);
    return (
      date.getFullYear() === y &&
      date.getMonth() === m - 1 &&
      date.getDate() === d
    );
  };

  if (!isValidDate(fullYear, month, day)) {
    throw new Error("CNP invalid: data nu este validă!");
  }

  // Formatul final dd/mm/yyyy
  const formattedDate = `${String(day).padStart(2, "0")}/${String(
    month
  ).padStart(2, "0")}/${fullYear}`;
  return formattedDate;
}

function parseMatricolNumber(input) {
  // Split the input string by '/'

  const parts = input.split("/");

  // Ensure the format is correct
  if (parts.length !== 3) {
    return input || "";
  }

  // Extract values
  const numarMatricol = parseInt(parts[0], 10);
  const volum = parts[1]; // Volume is in Roman numerals
  const pagina = parseInt(parts[2], 10);

  return {
    numarMatricol,
    volum,
    pagina,
  };
}
function Catalog({
  classData,
  setClassData,
  mode = "edit",
  permision,
  onFileGenerated,
  className,
}) {
  const [eleviData, setEleviData] = useState([]);
  const componentRef = useRef();
  const onlyWidth = useWindowWidth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gradesElevi, setGradesElevi] = useState([]);
  const [elevId, setElevId] = useState();
  const [elevId2, setElevId2] = useState();
  const [teza, setTeza] = useState();
  const [materieId, setMaterieId] = useState();
  const print = useRef();
  const [nota, setNota] = useState();
  const [inchideMediiAutomat, setInchideMediiAutomat] = useState(false);
  const [allData, setAllData] = useState({});
  const profesoriRedux = useSelector((state) => state.profesori);
  const settings = useSelector((state) => state.settings);
  const Limit = 40;
  const [deleted, setDeleted] = useState("");
  const [motivStergereMedie, setMotivStergereMedie] = useState("");
  const [notePrint, setNotePrint] = useState([]);
  const [author, setAuthor] = useState("");
  const navigate = useNavigate();
  const [comentariu, setComentariu] = useState();
  const [edit, setEdit] = useState(false);
  const clase = useSelector((state) => state.clase);

  const [faraNote, setFaraNote] = useState(false);
  const windowSize = useRef(window.innerWidth);
  const [data, setData] = useState();
  const user = useSelector((state) => state.user);
  const [wordDocuments, setWordDocuments] = useState([]);

  const [tip, setTip] = useState();
  const [entity, setEntity] = useState({});
  const [scutiri, setScutiri] = useState({});
  const [allNotes, setAllNotes] = useState([]);
  const [display, setDisplay] = useState(false);

  const [id, setId] = useState("");
  const [profileElevi, setProfileElevi] = useState({});
  const [open2, setOpen2] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const secondColumn = 12;
  const [profesori, setProfesori] = useState();
  useEffect(() => {
    const fetchAndCombine = async () => {
      const combined = await Promise.all(
        profesoriRedux.map(async (prof) => {
          try {
            const userSnap = await getDataDoc("users", prof.id);

            return {
              ...prof,
              ...userSnap,
            };
          } catch (error) {
            console.error("Eroare la descărcarea user-ului:", error);
            return prof;
          }
        })
      );

      setProfesori(combined);
    };
    if (profesoriRedux?.length) {
      fetchAndCombine();
    }
  }, [profesoriRedux]);
  const pref = [
    "Limba și literatura română",
    "Limba Engleză",
    "Limba Italiană",
    "Matematică",
    "Fizică",
    "Chimie",
    "Biologie",
    "Istorie",
    "Geografie",
    "Logică",
    "Religie",
    "Arte vizuale și abilități practice",
    "Educație fizică",
    "Teorie-solfegiu-dicteu",
    "Tehnologia informației și a comunicațiilor",
    "Etnografie și folclor muzical",
    "Muzică vocală tradițională românească",
    "Instrument la alegere - Vioară",
    "Instrument la alegere - Chitară",
    "Instrument la alegere - Clarinet",
    "Instrument la alegere - Flaut",
    "Instrument la alegere - Contrabas",
    "Corepetiție",
    "Ansamblu folcloric",
    "Istoria Muzicii",
    "Psihologie",
    "Educație Anteprenorială",
    "Economie",
    "Armonie",
    "Forme muzicale",
    "Muzică de cameră",
    "Consiliere și orientare / Purtare",
  ];

  function numarInLitere(numar) {
    if (numar === false) return "";
    if (numar === "" || numar === "undefined" || numar === undefined) return "";
    if (numar === "FB") return "(Foarte bine)";
    if (numar === "B") return "(Bine)";
    if (numar === "I") return "(Insuficient)";
    if (numar === "S") return "(Suficient)";
    const numarFloat = parseFloat(numar);
    if (isNaN(numarFloat) || numarFloat < 0 || numarFloat > 10) {
      return "Număr invalid. Introduceți un număr între 0 și 10 cu două zecimale sau fără.";
    }

    const intregi = [
      "zero",
      "unu",
      "doi",
      "trei",
      "patru",
      "cinci",
      "șase",
      "șapte",
      "opt",
      "nouă",
      "zece",
    ];

    const zecimale = [
      "zero",
      "unu",
      "doi",
      "trei",
      "patru",
      "cinci",
      "șase",
      "șapte",
      "opt",
      "nouă",
    ];

    const [parteaIntreaga, parteaZecimala] = numarFloat.toFixed(2).split(".");

    let rezultat = intregi[parseInt(parteaIntreaga, 10)];

    if (parteaZecimala && parseInt(parteaZecimala) > 0) {
      rezultat += " " + parteaZecimala + "%";
    }

    return "(" + rezultat + ")";
  }
  function containsDate(input) {
    // Regular expression to match two dates in the format dd.mm.yyyy
    const dateRegex = /(\b\d{1,2}\.\d{1,2}\.\d{4}\b)/g;

    // Find all matches in the string
    const matches = input.match(dateRegex);

    // Check if exactly two dates are found
    return matches && matches.length === 2;
  }

  // Exemple de utilizare:

  // Funcție helper pentru combinarea materiilor clasei cu materiile speciale ale elevului
  const combineMaterii = (elev) => {
    const materiiClasa = classData.materii || [];
    const materiiSpeciale = elev.materiiSpecialitate || [];

    // Separă materiile clasei în normale și Purtare
    const materiiNormale = [];
    let materiePurtare = null;

    materiiClasa.forEach((m) => {
      const materieData = materii?.find((mm) => mm.id === m.materie);
      if (materieData?.numeMaterie?.includes("Purtare")) {
        materiePurtare = m;
      } else {
        materiiNormale.push(m);
      }
    });

    // Set pentru a verifica duplicate (folosim ID-ul materiei)
    const materiiIDs = new Set(materiiNormale.map((m) => m.materie));

    // Adaugă materiile speciale care nu există deja în materiile normale
    const materiiSpecialeFiltrate = materiiSpeciale
      .filter((ms) => !materiiIDs.has(ms.materie))
      .map((ms) => ({
        materie: ms.materie,
        profesori: ms.profesori || [],
      }));

    // Combină: materii normale → materii speciale → Purtare
    const materiiCombinate = [
      ...materiiNormale,
      ...materiiSpecialeFiltrate,
      ...(materiePurtare ? [materiePurtare] : []),
    ];

    return materiiCombinate;
  };

  // Funcție helper pentru combinarea materiilor tuturor elevilor (pentru Coperta și Final)
  const combineToateMateriileElevilor = () => {
    const materiiClasa = classData.materii || [];
    const toateMateriileSpeciale = [];

    // Colectează toate materiile speciale de la toți elevii
    eleviData.forEach((elev) => {
      const materiiSpeciale = elev.materiiSpecialitate || [];
      materiiSpeciale.forEach((ms) => {
        // Verifică dacă materia nu există deja în lista de materii speciale
        if (!toateMateriileSpeciale.find((m) => m.materie === ms.materie)) {
          toateMateriileSpeciale.push({
            materie: ms.materie,
            profesori: ms.profesori || [],
          });
        }
      });
    });

    // Separă materiile clasei în normale și Purtare
    const materiiNormale = [];
    let materiePurtare = null;

    materiiClasa.forEach((m) => {
      const materieData = materii?.find((mm) => mm.id === m.materie);
      if (materieData?.numeMaterie?.includes("Purtare")) {
        materiePurtare = m;
      } else {
        materiiNormale.push(m);
      }
    });

    // Set pentru a verifica duplicate (folosim ID-ul materiei)
    const materiiIDs = new Set(materiiNormale.map((m) => m.materie));

    // Filtrează materiile speciale care nu există deja în materiile normale
    const materiiSpecialeFiltrate = toateMateriileSpeciale.filter(
      (ms) => !materiiIDs.has(ms.materie)
    );

    // Combină: materii normale → materii speciale → Purtare
    const materiiCombinate = [
      ...materiiNormale,
      ...materiiSpecialeFiltrate,
      ...(materiePurtare ? [materiePurtare] : []),
    ];

    return materiiCombinate;
  };

  const generateWordChunck = async (elevi) => {
    let cnt = 0;

    cnt = 0;
    let enct = 0;
    let materiiCatalog = {};

    for (let elev of elevi) {
      ++enct;
      let noReligie = gradesElevi[elev.id]?.note?.find(
        (n) =>
          (n.materieId.includes("Religie") ||
            n.materieId.includes("RP") ||
            n.materieId.includes("Penticostal")) &&
          (n.tip === "nota" ||
            ciclu(
              clase?.find((c) => c.id === classData.id),
              true
            ) === "preg")
      );

      cnt = 0;
      // Combină materiile clasei cu materiile speciale ale elevului
      const materiiElev = combineMaterii(elev);
      let total = materiiElev

        .filter((m) => {
          return (
            (noReligie === undefined &&
              m.materie.includes("Religie") &&
              !m.materie.includes("Penticostala") &&
              !m.materie.includes("RP")) ||
            (elev.scutitMedical &&
              materii
                .find((mm) => mm.id === m.materie)
                ?.numeMaterie?.toLowerCase()
                .includes("Educație fizică")) ||
            gradesElevi[elev.id]?.note?.find(
              (n) => n.materieId === m.materie
            ) ||
            (ciclu(
              clase?.find((c) => c.id === classData.id),
              true
            ) === "preg" &&
              !materii
                .find((mm) => mm.id === m.materie)
                ?.numeMaterie.includes("RP") &&
              !materii
                .find((mm) => mm.id === m.materie)
                ?.numeMaterie.includes("Penticostal") &&
              !(
                materii
                  .find((mm) => mm.id === m.materie)
                  ?.numeMaterie.includes("Religie") &&
                gradesElevi[elev.id]?.note?.find(
                  (n) =>
                    n.materieId.includes("RP") ||
                    n.materieId.includes("Penticostal")
                )
              )) ||
            classData.identificator === "S" ||
            materii
              .find((mm) => mm.id === m.materie)
              ?.numeMaterie.includes("Dezvoltare")
          );
        })
        .reduce((acc, m) => {
          ++cnt;
          let noti = classData.anClasa === "Pregătitoare" ? "_a1" : "_n";
          let prevCnt;
          if (
            materii
              ?.find((mm) => mm.id === m.materie)
              ?.numeMaterie.includes("Purtare")
          )
            prevCnt = getIndex(m.materie);
          else prevCnt = materiiElev.filter((mat) => {
            return (
              (noReligie === undefined &&
                mat.materie.includes("Religie") &&
                !mat.materie.includes("Penticostala") &&
                !mat.materie.includes("RP")) ||
              (elev.scutitMedical &&
                materii
                  .find((mm) => mm.id === mat.materie)
                  ?.numeMaterie?.toLowerCase()
                  .includes("Educație fizică")) ||
              gradesElevi[elev.id]?.note?.find(
                (n) => n.materieId === mat.materie
              ) ||
              (ciclu(
                clase?.find((c) => c.id === classData.id),
                true
              ) === "preg" &&
                !materii
                  .find((mm) => mm.id === mat.materie)
                  ?.numeMaterie.includes("RP") &&
                !materii
                  .find((mm) => mm.id === mat.materie)
                  ?.numeMaterie.includes("Penticostal") &&
                !(
                  materii
                    .find((mm) => mm.id === mat.materie)
                    ?.numeMaterie.includes("Religie") &&
                  gradesElevi[elev.id]?.note?.find(
                    (n) =>
                      n.materieId.includes("RP") ||
                      n.materieId.includes("Penticostal")
                  )
                )) ||
              classData.identificator === "S" ||
              materii
                .find((mm) => mm.id === mat.materie)
                ?.numeMaterie.includes("Dezvoltare")
            );
          }).findIndex((f) => f.materie === m.materie) + 1;

          return {
            ...acc,
            ...(materii
              .find((mm) => mm.id === m.materie)
              ?.numeMaterie?.toLowerCase()
              .includes("Educație fizică") &&
            elev?.scutitMedical?.length > 0 &&
            elev.scutitMedical !== "nu"
              ? {
                  ["e" + enct + noti + "_m" + prevCnt]: {
                    text: `${
                      gradesElevi[elev.id]?.note?.find(
                        (n) => n.materieId === m.materie && n.tip === "nota"
                      )
                        ? gradesElevi[elev.id].note
                            .filter(
                              (n) =>
                                n.materieId === m.materie && n.tip === "nota"
                            )
                            .map(
                              (n) =>
                                `${n.nota}/${formatDate(
                                  new Date(n.date),
                                  "nota"
                                )}`
                            )
                            .join(", ") + "\n"
                        : ""
                    }-Scutit medical conform ${elev.scutitMedical}${
                      elev?.dataExpirareMedical
                        ? ` până pe data de ${new Date(
                            elev.dataExpirareMedical
                          ).toLocaleDateString()}`
                        : ""
                    }`,
                  },
                }
              : {}),
            ...(!noReligie &&
            materii
              .find((mm) => mm.id === m.materie)
              ?.numeMaterie.includes("Religie")
              ? {
                  ["e" + enct + noti + "_m" + prevCnt]: {
                    text:
                      process.env.REACT_APP_NAME ===
                      `Școala Gimnazială "Mihai Eminescu" Năsăud`
                        ? elev?.religie?.toLowerCase().trim() === "da" ||
                          !elev?.religie
                          ? ""
                          : elev?.religie?.toLowerCase().trim() === "nu"
                          ? "\n RETRAS "
                          : "Retras conform:" + elev?.religie
                        : elev?.religie?.toLowerCase().trim() === "da"
                        ? "\n RETRAS "
                        : !elev?.religie ||
                          elev?.religie?.toLowerCase().trim() === "nu"
                        ? ""
                        : "Retras conform:" + elev?.religie,
                  },
                }
              : {}),
            ["e" + enct + "_" + "mat" + prevCnt]: materii?.find(
              (mm) => mm.id === m.materie
            )?.numeMaterie,
          };
        }, {});
      materiiCatalog = { ...materiiCatalog, ...total };
    }

    cnt = 0;
    let dateElevi = elevi.reduce((acc, e) => {
      let noReligie = gradesElevi[e.id]?.note?.find(
        (n) =>
          n.materieId.includes("Religie") ||
          n.materieId.includes("RP") ||
          n.materieId.includes("Penticostal")
      );

      // Combină materiile clasei cu materiile speciale ale elevului
      const materiiElev = combineMaterii(e);

      ++cnt;
      return {
        ...acc,
        ["e" + cnt + "_nf"]:
          eleviData?.findIndex((el) => el.id === e.id) +
          1 +
          ". " +
          e.numeDeFamilie +
          " " +
          (e.initiala || ""),
        ["e" + cnt + "_pr"]: e.prenume,
        ["e" + cnt + "_nrmat"]: e.numarMatricol,
        ["e" + cnt + "_nrMatricol"]: parseMatricolNumber(e.numarMatricol)
          .numarMatricol,
        ["e" + cnt + "_v"]: parseMatricolNumber(e.numarMatricol).volum,
        ["e" + cnt + "_p"]: parseMatricolNumber(e.numarMatricol).pagina,
        ["e" + cnt + "_crt"]: cnt,
        ["e" + cnt + "_fullname"]:
          e.numeDeFamilie + " " + e.initiala + " " + e.prenume,
        ["e" + cnt + "_mama"]: "",
        ["e" + cnt + "_tata"]: "",
        ["e" + cnt + "_dom_nr_telefon"]:
          (e.domiciliu || "") +
          (e.domiciliu && e.numarTelefon ? ", " : "") +
          (e.numarTelefon || ""),
        ["e" + cnt + "_ta"]:
          gradesElevi[e.id].absente.absente_dupa_motivari?.length,
        ["e" + cnt + "_abs_n"]:
          gradesElevi[e.id].absente.absente_nemotivate?.length,
        ["e" + cnt + "_med1"]:
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor !== "-" &&
          e.mutat !== true &&
          e.retras !== true
            ? e.stareaLaIncheiereaCursurilor
            : "\n",
        // e.retras || e.mutat
        //   ? ""
        //   : ciclu(clase?.find((c) => c.id === e.clasa)) == "liceu" ||
        //     ciclu(clase?.find((c) => c.id === e.clasa)) == "gimnaziu"
        //   ? calculare_stare_before(
        //       gradesElevi[e.id]?.note || [],
        //       materii,
        //       scutiri[e.id]
        //     )
        //   : "Promovat",
        ["e" + cnt + "_med2"]:
          e.stareaLaFinalulAnului &&
          e.stareaLaFinalulAnului !== "-" &&
          e.mutat !== true &&
          e.retras !== true
            ? e.stareaLaFinalulAnului
            : "\n",
        // e.retras || e.mutat
        //   ? ""
        //   : ciclu(clase?.find((c) => c.id === e.clasa)) == "liceu" ||
        //     ciclu(clase?.find((c) => c.id === e.clasa)) == "gimnaziu"
        //   ? calculare_stare_after(
        //       gradesElevi[e.id]?.note || [],
        //       materii,
        //       scutiri[e.id]
        //     )
        //   : "Promovat",
        ["e" + cnt + "_medg"]:
          e.stareaLaFinalulAnului?.toLowerCase()?.trim().includes("promovat") &&
          e.mutat !== true &&
          e.retras !== true
            ? calculare_medii(
                gradesElevi[e.id]?.note || [],
                materii,
                scutiri[e.id]
              ) +
              " " +
              numarInLitere(
                calculare_medii(
                  gradesElevi[e.id]?.note || [],
                  materii,
                  scutiri[e.id]
                )
              )
            : "",
        // e.retras === true || e.mutat === true
        //   ? ""
        //   : (ciclu(clase?.find((c) => c.id === e.clasa)) === "liceu" ||
        //       clase?.find((c) => c.id === e.clasa) === "gimnaziu") &&
        //     calculare_stare_after(
        //       gradesElevi[e.id]?.note || [],
        //       materii,
        //       scutiri[e.id]
        //     ) === "Promovat"
        //   ? "Medie generală:" +
        //     calculare_medii(
        //       gradesElevi[e.id]?.note || [],
        //       materii,
        //       scutiri[e.id]
        //     )
        //   : "",
        ["e" + cnt + "_detalii"]:
          (e.ces === "da" ? "Cerințe educaționale speciale\n" : "") +
          (e.details ||
            ((e.transferuri || []).length === 0 ? e.detalii : "") ||
            "") +
          "\n" +
          (e.transferuri || []).reduce(
            (acc, cur) => acc + cur.details + "\n",
            ""
          ),
        ...gradesElevi[e.id].absente.absente_dupa_motivari?.reduce(
          (acc, n) => {
            let indexMaterie = materii
              .find((mm) => mm.id === n.materieId)
              .numeMaterie.includes("Purtare")
              ? getIndex(n.materieId)
              : materiiElev
                  .filter((m) => {
                    return (
                      (noReligie === undefined &&
                        m.materie.includes("Religie") &&
                        !m.materie.includes("Penticostala") &&
                        !m.materie.includes("RP")) ||
                      (e.scutitMedical &&
                        materii
                          .find((mm) => mm.id === m.materie)
                          ?.numeMaterie?.toLowerCase()
                          .includes("Educație fizică")) ||
                      gradesElevi[e.id]?.note?.find(
                        (n) => n.materieId === m.materie
                      ) ||
                      (ciclu(
                        clase?.find((c) => c.id === classData.id),
                        true
                      ) === "preg" &&
                        !materii
                          .find((mm) => mm.id === m.materie)
                          ?.numeMaterie.includes("RP") &&
                        !materii
                          .find((mm) => mm.id === m.materie)
                          ?.numeMaterie.includes("Penticostal") &&
                        !(
                          materii
                            .find((mm) => mm.id === m.materie)
                            ?.numeMaterie.includes("Religie") &&
                          gradesElevi[e.id]?.note?.find(
                            (n) =>
                              n.materieId.includes("RP") ||
                              n.materieId.includes("Penticostal")
                          )
                        )) ||
                      classData.identificator === "S" ||
                      materii
                        .find((mm) => mm.id === m.materie)
                        ?.numeMaterie.includes("Dezvoltare")
                    );
                  })
                  .findIndex((a) => a.materie === n.materieId) + 1;

            let which = 1;

            if (n.tip === "absenta") {
              // Group absences by subject for this student
              const absencesForSubject = gradesElevi[
                e.id
              ].absente.absente_dupa_motivari.filter(
                (abs) => abs.materieId === n.materieId && abs.tip === "absenta"
              );

              // Only process if this is the first absence for this subject (to avoid duplicates)
              const isFirstForSubject =
                acc["e" + cnt + "_a" + which + "_m" + indexMaterie] ===
                undefined;

              if (isFirstForSubject) {
                const formattedText = formatAbsencesGrouped(absencesForSubject);
                return {
                  ...acc,
                  ["e" + cnt + "_a" + which + "_m" + indexMaterie]: [
                    {
                      text: formattedText,
                    },
                  ],
                };
              }
              return acc;
            }
            if (n.tip === "nota") {
              return {
                ...acc,
                ["e" + cnt + "_n" + "_m" + indexMaterie]: [
                  ...(acc?.["e" + cnt + "_n" + "_m" + indexMaterie] || []),
                  {
                    text: " ",
                  },
                  {
                    text: n.nota + formatDate(new Date(n.date), "nota"),
                  },
                ],
              };
            }
          },

          {
            ["e" + cnt + "_a" + "_m" + 1]: [],
            ["e" + cnt + "_a" + "_m" + 2]: [],
            ["e" + cnt + "_a" + "_m" + 3]: [],
            ["e" + cnt + "_a" + "_m" + 4]: [],
            ["e" + cnt + "_a" + "_m" + 5]: [],
            ["e" + cnt + "_a" + "_m" + 6]: [],
            ["e" + cnt + "_a" + "_m" + 7]: [],
            ["e" + cnt + "_a" + "_m" + 8]: [],
            ["e" + cnt + "_a" + "_m" + 9]: [],
            ["e" + cnt + "_a" + "_m" + 10]: [],
            ["e" + cnt + "_a" + "_m" + 11]: [],
            ["e" + cnt + "_a" + "_m" + 12]: [],
            ["e" + cnt + "_a" + "_m" + 13]: [],
            ["e" + cnt + "_a" + "_m" + 14]: [],
            ["e" + cnt + "_a" + "_m" + 15]: [],
            ["e" + cnt + "_a" + "_m" + 16]: [],
            ["e" + cnt + "_a" + "_m" + 17]: [],
            ["e" + cnt + "_a" + "_m" + 18]: [],
            ["e" + cnt + "_a" + "_m" + 19]: [],
            ["e" + cnt + "_a" + "_m" + 20]: [],
            ["e" + cnt + "_a" + "_m" + 21]: [],
            ["e" + cnt + "_a" + "_m" + 22]: [],
            ["e" + cnt + "_a" + "_m" + 23]: [],
            ["e" + cnt + "_a" + "_m" + 24]: [],
            ["e" + cnt + "_a" + "_m" + 25]: [],
            ["e" + cnt + "_a" + "_m" + 26]: [],
            ["e" + cnt + "_a" + "_m" + 27]: [],
          }
        ),
        ...gradesElevi[e.id].note
          ?.sort((a, b) => {
            // First priority: examen_final goes last
            if (a.tip === "examen_final" && b.tip !== "examen_final") return 1;
            if (a.tip !== "examen_final" && b.tip === "examen_final") return -1;

            // Second priority: sort by date
            return new Date(a.date) - new Date(b.date);
          })
          .reduce(
            (acc, n) => {
              let indexMaterie = materii
                .find((mm) => mm.id === n.materieId)
                .numeMaterie.includes("Purtare")
                ? getIndex(n.materieId)
                : materiiElev
                    .filter((m) => {
                      return (
                        (noReligie === undefined &&
                          m.materie.includes("Religie") &&
                          !m.materie.includes("Penticostala") &&
                          !m.materie.includes("RP")) ||
                        (e.scutitMedical &&
                          materii
                            .find((mm) => mm.id === m.materie)
                            ?.numeMaterie?.toLowerCase()
                            .includes("Educație fizică")) ||
                        gradesElevi[e.id]?.note?.find(
                          (n) => n.materieId === m.materie
                        ) ||
                        (ciclu(
                          clase?.find((c) => c.id === classData.id),
                          true
                        ) === "preg" &&
                          !materii
                            .find((mm) => mm.id === m.materie)
                            ?.numeMaterie.includes("RP") &&
                          !materii
                            .find((mm) => mm.id === m.materie)
                            ?.numeMaterie.includes("Penticostal") &&
                          !(
                            materii
                              .find((mm) => mm.id === m.materie)
                              ?.numeMaterie.includes("Religie") &&
                            gradesElevi[e.id]?.note?.find(
                              (n) =>
                                n.materieId.includes("RP") ||
                                n.materieId.includes("Penticostal")
                            )
                          )) ||
                        classData.identificator === "S" ||
                        materii
                          .find((mm) => mm.id === m.materie)
                          ?.numeMaterie.includes("Dezvoltare")
                      );
                    })
                    .findIndex((a) => a.materie === n.materieId) + 1;
              if (n.tip === "examen_final")
                return {
                  ...acc,
                  ["e" + cnt + "_n" + "_m" + indexMaterie]: [
                    ...(acc?.["e" + cnt + "_n" + "_m" + indexMaterie] || []),
                    {
                      text: " ",
                    },
                    {
                      text:
                        "Ex. final:\n" +
                        truncateFloat(n.examen_final) +
                        "/\n" +
                        formatDate(new Date(n.date)),
                    },
                  ],
                };

              if (n.tip === "nota") {
                return {
                  ...acc,
                  ["e" + cnt + "_n" + "_m" + indexMaterie]: [
                    ...(acc?.["e" + cnt + "_n" + "_m" + indexMaterie] || []),

                    {
                      text: n.nota + "/" + formatDate(new Date(n.date), "nota"),
                    },
                  ],
                };
              }
              return acc;
            },
            {
              ["e" + cnt + "_n" + "_m" + 1]: [],
              ["e" + cnt + "_n" + "_m" + 2]: [],
              ["e" + cnt + "_n" + "_m" + 3]: [],
              ["e" + cnt + "_n" + "_m" + 4]: [],
              ["e" + cnt + "_n" + "_m" + 5]: [],
              ["e" + cnt + "_n" + "_m" + 6]: [],
              ["e" + cnt + "_n" + "_m" + 7]: [],
              ["e" + cnt + "_n" + "_m" + 8]: [],
              ["e" + cnt + "_n" + "_m" + 9]: [],
              ["e" + cnt + "_n" + "_m" + 10]: [],
              ["e" + cnt + "_n" + "_m" + 11]: [],
              ["e" + cnt + "_n" + "_m" + 12]: [],
              ["e" + cnt + "_n" + "_m" + 13]: [],
              ["e" + cnt + "_n" + "_m" + 14]: [],
              ["e" + cnt + "_n" + "_m" + 15]: [],
              ["e" + cnt + "_n" + "_m" + 16]: [],
              ["e" + cnt + "_n" + "_m" + 17]: [],
              ["e" + cnt + "_n" + "_m" + 18]: [],
              ["e" + cnt + "_n" + "_m" + 19]: [],
              ["e" + cnt + "_n" + "_m" + 20]: [],
              ["e" + cnt + "_n" + "_m" + 21]: [],
              ["e" + cnt + "_n" + "_m" + 22]: [],
              ["e" + cnt + "_n" + "_m" + 23]: [],
              ["e" + cnt + "_n" + "_m" + 24]: [],
              ["e" + cnt + "_n" + "_m" + 25]: [],
              ["e" + cnt + "_n" + "_m" + 26]: [],
              ["e" + cnt + "_n" + "_m" + 27]: [],
            }
          ),
        ...materiiElev
          .filter((m) => {
            return (
              (noReligie === undefined &&
                m.materie.includes("Religie") &&
                !m.materie.includes("Penticostala") &&
                !m.materie.includes("RP")) ||
              (e.scutitMedical &&
                materii
                  .find((mm) => mm.id === m.materie)
                  ?.numeMaterie?.toLowerCase()
                  .includes("Educație fizică")) ||
              gradesElevi[e.id]?.note?.find((n) => n.materieId === m.materie) ||
              (ciclu(
                clase?.find((c) => c.id === classData.id),
                true
              ) === "preg" &&
                !materii
                  .find((mm) => mm.id === m.materie)
                  ?.numeMaterie.includes("RP") &&
                !materii
                  .find((mm) => mm.id === m.materie)
                  ?.numeMaterie.includes("Penticostal") &&
                !(
                  materii
                    .find((mm) => mm.id === m.materie)
                    ?.numeMaterie.includes("Religie") &&
                  gradesElevi[e.id]?.note?.find(
                    (n) =>
                      n.materieId.includes("RP") ||
                      n.materieId.includes("Penticostal")
                  )
                )) ||
              classData.identificator === "S" ||
              materii
                .find((mm) => mm.id === m.materie)
                ?.numeMaterie.includes("Dezvoltare")
            );
          })
          .reduce((acc, m) => {
            const indexCalculat = materii
              ?.find((f) => f.id === m.materie)
              .numeMaterie.includes("Purtare")
              ? getIndex(m.materie)
              : materiiElev
                  .filter((mat) => {
                    return (
                      (noReligie === undefined &&
                        mat.materie.includes("Religie") &&
                        !mat.materie.includes("Penticostala") &&
                        !mat.materie.includes("RP")) ||
                      (e.scutitMedical &&
                        materii
                          .find((mm) => mm.id === mat.materie)
                          ?.numeMaterie?.toLowerCase()
                          .includes("Educație fizică")) ||
                      gradesElevi[e.id]?.note?.find(
                        (n) => n.materieId === mat.materie
                      ) ||
                      (ciclu(
                        clase?.find((c) => c.id === classData.id),
                        true
                      ) === "preg" &&
                        !materii
                          .find((mm) => mm.id === mat.materie)
                          ?.numeMaterie.includes("RP") &&
                        !materii
                          .find((mm) => mm.id === mat.materie)
                          ?.numeMaterie.includes("Penticostal") &&
                        !(
                          materii
                            .find((mm) => mm.id === mat.materie)
                            ?.numeMaterie.includes("Religie") &&
                          gradesElevi[e.id]?.note?.find(
                            (n) =>
                              n.materieId.includes("RP") ||
                              n.materieId.includes("Penticostal")
                          )
                        )) ||
                      classData.identificator === "S" ||
                      materii
                        .find((mm) => mm.id === mat.materie)
                        ?.numeMaterie.includes("Dezvoltare")
                    );
                  })
                  ?.findIndex((f) => f.materie === m.materie) + 1;

            return {
              ...acc,
              ["e" + cnt + "_m" + indexCalculat]:
                e.retras === true || e.mutat === true
                  ? ""
                  : (gradesElevi[e.id]?.note || []).filter(
                      (n) =>
                        n.materieId === m.materie && n.tip === "inchidere_medie"
                    ).length >= 1
                  ? (calculeaza_medie_materie(
                      (gradesElevi[e.id]?.note || []).filter(
                        (n) => new Date(n.date) < new Date("2025-06-21")
                      ),
                      materii?.find((f) => f.id === m.materie),
                      scutiri[e.id]
                    ).medie ||
                      calculeaza_medie_materie(
                        (gradesElevi[e.id]?.note || []).filter(
                          (n) => new Date(n.date) < new Date("2025-06-21")
                        ),
                        materii?.find((f) => f.id === m.materie),
                        scutiri[e.id]
                      ).medie) +
                    numarInLitere(
                      calculeaza_medie_materie(
                        (gradesElevi[e.id]?.note || []).filter(
                          (n) => new Date(n.date) < new Date("2025-06-21")
                        ),
                        materii?.find((f) => f.id === m.materie),
                        scutiri[e.id]
                      ).medie ||
                        calculeaza_medie_materie(
                          (gradesElevi[e.id]?.note || []).filter(
                            (n) => new Date(n.date) < new Date("2025-06-21")
                          ),
                          materii?.find((f) => f.id === m.materie),
                          scutiri[e.id]
                        ).medie
                    )
                  : "",

              ["e" + cnt + "_mc" + indexCalculat]:
                calculeaza_medie_materie(
                  gradesElevi[e.id]?.note || [],
                  materii?.find((f) => f.id === m.materie),
                  scutiri[e.id]
                )?.corigenta === undefined ||
                calculeaza_medie_materie(
                  gradesElevi[e.id]?.note || [],
                  materii?.find((f) => f.id === m.materie),
                  scutiri[e.id]
                )?.corigenta === false
                  ? ""
                  : calculeaza_medie_materie(
                      gradesElevi[e.id]?.note || [],
                      materii?.find((f) => f.id === m.materie),
                      scutiri[e.id]
                    )?.corigenta?.corigenta +
                    numarInLitere(
                      calculeaza_medie_materie(
                        gradesElevi[e.id]?.note || [],
                        materii?.find((f) => f.id === m.materie),
                        scutiri[e.id]
                      )?.corigenta === undefined
                        ? ""
                        : calculeaza_medie_materie(
                            gradesElevi[e.id]?.note || [],
                            materii?.find((f) => f.id === m.materie),
                            scutiri[e.id]
                          )?.corigenta?.corigenta
                    ),
              ["e" + cnt + "_a" + indexCalculat]:
                e.retras === true || e.mutat === true
                  ? ""
                  : (calculeaza_medie_materie(
                      gradesElevi[e.id]?.note || [],
                      materii?.find((f) => f.id === m.materie),
                      scutiri[e.id]
                    ).inchis.inchidere_medie || "") +
                    " " +
                    numarInLitere(
                      calculeaza_medie_materie(
                        gradesElevi[e.id]?.note || [],
                        materii?.find((f) => f.id === m.materie),
                        scutiri[e.id]
                      ).inchis.inchidere_medie || ""
                    ),
            };
          }, {}),
      };
    }, {});
    cnt = 1;

    const templateArrayBuffer = await fetchTemplateRubrica();
    const zip = new PizZip(templateArrayBuffer);

    const templateDoc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });
    let generatedObject = {};
    for (let e = 1; e <= 35; e++) {
      for (let m = 1; m <= 30; m++) {
        generatedObject[`e${e}_m${m}`] = "";

        generatedObject[`e${e}_mc${m}`] = "";
        generatedObject[`e${e}_mat${m}`] = "";
        generatedObject[`e${e}_a${m}`] = "";
        generatedObject[`e${e}_ta`] = "";
        generatedObject[`e${e}_abs_n`] = "";
        generatedObject["e" + e + "_crt"] = "";
        generatedObject["e" + e + "_nf"] = "";
        generatedObject["e" + e + "_pr"] = "";
        generatedObject["e" + e + "_ta"] = "";
        generatedObject["e" + e + "_abs_n"] = "";
        generatedObject["e" + e + "_med1"] = "";
        generatedObject["e" + e + "_med2"] = "";
        generatedObject["e" + e + "_medg"] = "";
        generatedObject["e" + e + "_detalii"] = "";
        generatedObject["e" + e + "_nrmat"] = "";
        generatedObject["e" + e + "_fullname"] = "";
        generatedObject["e" + e + "_nastere"] = "";
        generatedObject["e" + e + "_mama"] = "";
        generatedObject["e" + e + "_tata"] = "";
        generatedObject["e" + e + "_dom_nr_telefon"] = "";
        generatedObject["e" + e + "_v"] = "";
        generatedObject["e" + e + "_p"] = "";
        generatedObject["e" + e + "_nrMatricol"] = "";
      }
    }

    const resume = {
      e1_med1: "",
      e1_med2: "",
      e1_medg: "",
      e2_med1: "",
      e2_med2: "",
      e2_medg: "",
      e3_med1: "",
      e3_med2: "",
      e3_medg: "",
      e4_med1: "",
      e4_med2: "",
      e4_medg: "",
      e5_med1: "",
      e5_med2: "",
      e5_medg: "",
      e6_med1: "",
      e6_med2: "",
      e6_medg: "",
      e7_med1: "",
      e7_med2: "",
      e7_medg: "",
      e8_med1: "",
      e8_med2: "",
      e8_medg: "",
      e9_med1: "",
      e9_med2: "",
      e9_medg: "",
      e10_med1: "",
      e10_med2: "",
      e10_medg: "",
      e11_med1: "",
      e11_med2: "",
      e11_medg: "",
      e12_med1: "",
      e12_med2: "",
      e12_medg: "",
      e13_med1: "",
      e13_med2: "",
      e13_medg: "",
      e14_med1: "",
      e14_med2: "",
      e14_medg: "",
      e15_med1: "",
      e15_med2: "",
      e15_medg: "",
      e16_med1: "",
      e16_med2: "",
      e16_medg: "",
      e17_med1: "",
      e17_med2: "",
      e17_medg: "",
      e18_med1: "",
      e18_med2: "",
      e18_medg: "",
      e19_med1: "",
      e19_med2: "",
      e19_medg: "",
      e20_med1: "",
      e20_med2: "",
      e20_medg: "",
      e21_med1: "",
      e21_med2: "",
      e21_medg: "",
      e22_med1: "",
      e22_med2: "",
      e22_medg: "",
      e23_med1: "",
      e23_med2: "",
      e23_medg: "",
      e24_med1: "",
      e24_med2: "",
      e24_medg: "",
      e25_med1: "",
      e25_med2: "",
      e25_medg: "",
      e26_med1: "",
      e26_med2: "",
      e26_medg: "",
      e27_med1: "",
      e27_med2: "",
      e27_medg: "",
      e28_med1: "",
      e28_med2: "",
      e28_medg: "",
      e29_med1: "",
      e29_med2: "",
      e29_medg: "",
      e30_med1: "",
      e30_med2: "",
      e30_medg: "",

      ...{
        m1: "",
        m2: "",
        m3: "",
        m4: "",
        m5: "",
        m6: "",
        m7: "",
        m8: "",
        m9: "",
        m10: "",
        m11: "",
        m12: "",
        m13: "",
        m14: "",
        m15: "",
        m16: "",
        m17: "",
        m18: "",
        m19: "",
        m20: "",
        m21: "",
        m22: "",
        m23: "",
        m24: "",
        m25: "",
        m26: "",
        m27: "",
        m28: "",
        m29: "",
        m30: "",
        m31: "",
        m32: "",
        m33: "",
        m34: "",
        m35: "",
        m36: "",
        m37: "",
        m38: "",
      },
      ...materiiCatalog,
      ...dateElevi,
    };
    templateDoc.render({
      ...generatedObject,
      ...resume,
      ...dateElevi,
      ...materiiCatalog,
    });

    const generatedDoc = templateDoc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });
    const zipFromGeneratedDoc = new PizZip(await generatedDoc.arrayBuffer());

    // Modifică XML-ul documentului
    const modifiedZip = modifyDocumentXML(zipFromGeneratedDoc);

    // Generează documentul final cu modificările aplicate
    const finalGeneratedDoc = modifiedZip.generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });

    // Salvează documentul final

    return finalGeneratedDoc;
  };

  const readBlobAsArrayBuffer = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(blob);
    });
  };
  const mergeWordDocuments = async (wordDocuments) => {
    if (wordDocuments.length < 2) {
      alert("Selectează cel puțin două documente.");
      return;
    }

    try {
      // Convertim fișierele în Base64 folosind FileReader
      const base64Files = await Promise.all(
        wordDocuments.map((doc) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(doc);
            reader.onloadend = () => {
              // Eliminăm prefixul "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,"
              const base64String = reader.result.split(",")[1];
              resolve(base64String);
            };
            reader.onerror = reject;
          });
        })
      );

      // Apelăm funcția Firebase pentru merge cu timeout extins
      const functions = getFunctions();
      const mergeDocs = httpsCallable(functions, "mergeWordDocuments", {
        timeout: 300000, // 5 minute timeout
      });
      const response = await mergeDocs({ files: base64Files });

      // Decodăm fișierul Word final și îl descărcăm direct
      const wordBlob = new Blob(
        [
          Uint8Array.from(atob(response.data.mergedFile), (c) =>
            c.charCodeAt(0)
          ),
        ],
        {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }
      );

      // Generăm numele fișierului cu renderClassName
      const fileName = `${renderClassName(classData)}-catalog-export.docx`;
      const pdfFileName = `${renderClassName(classData)}-catalog-export.pdf`;

      // Pentru modul export-zip, convertim în PDF și trimitem ambele fișiere
      if (mode === "export-zip" && onFileGenerated) {
        console.log("🔄 Începe conversia Word → PDF pentru:", fileName);
        try {
          // Convertim Word-ul în Base64 pentru Firebase
          const wordBase64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = reader.result.split(",")[1]; // Remove data:application/... prefix
              resolve(base64);
            };
            reader.readAsDataURL(wordBlob);
          });

          console.log("📄 Word convertit în Base64, apelează Firebase...");

          // Apelăm funcția Firebase pentru conversia în PDF
          const functions = getFunctions();
          const convertWordToPdf = httpsCallable(functions, "convertWordToPdf");

          const result = await convertWordToPdf({ file: wordBase64 });

          // Convertim PDF-ul Base64 înapoi în Blob
          const pdfBlob = new Blob(
            [
              Uint8Array.from(atob(result.data.pdfFile), (c) =>
                c.charCodeAt(0)
              ),
            ],
            { type: "application/pdf" }
          );

          console.log(
            "📦 Trimite ambele fișiere:",
            fileName,
            "și",
            pdfFileName
          );
          // Trimitem ambele fișiere
          onFileGenerated(fileName, wordBlob, pdfFileName, pdfBlob);
        } catch (error) {
          console.error("❌ Eroare la conversia în PDF:", error);
          // Dacă conversia PDF eșuează, trimitem doar Word-ul
          console.log("📄 Trimite doar Word-ul din cauza erorii");
          onFileGenerated(fileName, wordBlob);
        }
      } else {
        // Pentru modul normal, creăm și PDF și descărcăm ZIP cu ambele
        console.log(
          "🔄 Începe conversia Word → PDF pentru descărcare singulară..."
        );
        try {
          // Convertim Word-ul în Base64 pentru Firebase
          const wordBase64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = reader.result.split(",")[1]; // Remove data:application/... prefix
              resolve(base64);
            };
            reader.readAsDataURL(wordBlob);
          });

          console.log("📄 Word convertit în Base64, apelează Firebase...");

          // Apelăm funcția Firebase pentru conversia în PDF
          const functions = getFunctions();
          const convertWordToPdf = httpsCallable(functions, "convertWordToPdf");
          const result = await convertWordToPdf({ file: wordBase64 });

          console.log("✅ PDF primit de la Firebase, convertește în Blob...");
          console.log(
            "🔍 Verifică datele PDF primite:",
            typeof result.data.pdfFile,
            result.data.pdfFile?.substring(0, 100)
          );

          // Validăm că avem date PDF valide
          if (!result.data.pdfFile || typeof result.data.pdfFile !== "string") {
            throw new Error(
              "PDF-ul primit de la Firebase este invalid sau gol"
            );
          }

          // Convertim PDF-ul Base64 înapoi în Blob
          let pdfBlob;
          try {
            const pdfBase64Data = result.data.pdfFile.trim();
            console.log(
              "🔍 Lungimea string-ului Base64:",
              pdfBase64Data?.length
            );

            const binaryString = atob(pdfBase64Data);
            pdfBlob = new Blob(
              [Uint8Array.from(binaryString, (c) => c.charCodeAt(0))],
              { type: "application/pdf" }
            );
            console.log(
              "✅ PDF Blob creat cu succes, mărime:",
              pdfBlob.size,
              "bytes"
            );
          } catch (base64Error) {
            console.error(
              "❌ Eroare la decodarea Base64 a PDF-ului:",
              base64Error
            );
            throw new Error(
              "Eroare la decodarea Base64 a PDF-ului: " + base64Error.message
            );
          }

          // Creăm ZIP cu ambele fișiere
          const JSZip = (await import("jszip")).default;
          const zip = new JSZip();

          const pdfFileName = fileName.replace(".docx", ".pdf");
          zip.file(fileName, wordBlob);
          zip.file(pdfFileName, pdfBlob);

          const zipBlob = await zip.generateAsync({ type: "blob" });
          const zipFileName = fileName.replace(".docx", "_Catalog.zip");

          console.log("📦 Descarcă ZIP cu Word și PDF:", zipFileName);
          saveAs(zipBlob, zipFileName);
        } catch (error) {
          console.error(
            "❌ Eroare la conversia în PDF pentru descărcare singulară:",
            error
          );
          // Dacă conversia PDF eșuează, descărcăm doar Word-ul
          console.log("📄 Descarcă doar Word-ul din cauza erorii");
          saveAs(wordBlob, fileName);
        }
      }
    } catch (error) {
      console.error("Eroare la descărcarea documentului:", error);

      if (error.code === "deadline-exceeded") {
        alert(
          "Operația a expirat. Documentele sunt prea mari sau conexiunea este lentă. Încearcă din nou cu documente mai mici."
        );
      } else if (error.code === "unavailable") {
        alert(
          "Serviciul este temporar indisponibil. Te rugăm să încerci din nou în câteva momente."
        );
      } else {
        alert(
          "A apărut o eroare la procesarea documentelor. Te rugăm să verifici fișierele și să încerci din nou."
        );
      }
    }
  };
  function groupArrayIntoChunks(array, chunkSize = 3) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }

  const fetchTemplateCoperta = async () => {
    const response = await fetch(
      ciclu(clase?.find((c) => c.id === classData.id)) === "primar"
        ? catalogPrimarCoperta
        : ciclu(clase?.find((c) => c.id === classData.id)) === "liceu"
        ? catalogLiceuCoperta
        : cataloggimnaziuCoperta
    );
    return await response.arrayBuffer();
  };
  const fetchTemplateFinal = async () => {
    const response = await fetch(
      ciclu(clase?.find((c) => c.id === classData.id)) === "primar"
        ? catalogPrimarFinal
        : ciclu(clase?.find((c) => c.id === classData.id)) === "liceu"
        ? catalogLiceuFinal
        : cataloggimnaziuFinal
    );
    return await response.arrayBuffer();
  };
  const fetchTemplateRubrica = async () => {
    const response = await fetch(
      ciclu(
        clase?.find((c) => c.id === classData.id),
        true
      ) === "preg"
        ? cataloggimnaziuPreg
        : ciclu(
            clase?.find((c) => c.id === classData.id),
            true
          ) === "primar"
        ? catalogprimarRubrica
        : ciclu(
            clase?.find((c) => c.id === classData.id),
            true
          ) === "liceu"
        ? catalogliceuRubrica
        : cataloggimnaziuRubrica
    );
    return await response.arrayBuffer();
  };

  function modifyDocumentXML(zip) {
    const xmlPath = "word/document.xml";
    let documentXml = zip.file(xmlPath).asText();

    // Parsează XML-ul într-un DOM
    const parser = new DOMParser();
    const serializer = new XMLSerializer();
    const xmlDoc = parser.parseFromString(documentXml, "application/xml");

    // Găsește toate nodurile <w:t> (text) și le procesează în ordine inversă
    // pentru a evita probleme cu modificarea DOM-ului în timp ce iterez
    const textNodes = Array.from(xmlDoc.getElementsByTagName("w:t"));

    // Procesez nodurile în ordine inversă
    for (let i = textNodes.length - 1; i >= 0; i--) {
      const node = textNodes[i];
      const textContent = node.textContent;

      // Caută pattern-uri care conțin "xyzg"
      if (textContent && textContent.includes("xyzg")) {
        // Procesează textul pentru a înlocui xyzg cu format cu border și \n cu line breaks
        let modifiedText = textContent.replace(/xyzg(\d+)/g, (match, day) => {
          return `⟦${day}⟧`; // Folosesc caractere speciale temporare
        });

        // Apoi procesez caracterele speciale și newline-urile
        const parentRun = node.parentNode;
        const paragraph = parentRun.parentNode;

        // Împart textul în părți (includ și newline-urile)
        const parts = modifiedText.split(/(⟦\d+⟧|\n)/);

        // Creez run-uri noi pentru fiecare parte ÎNAINTE să șterge run-ul original
        const newRuns = [];

        parts.forEach((part) => {
          if (part.match(/⟦(\d+)⟧/)) {
            // Partea cu border
            const day = part.replace(/⟦(\d+)⟧/, "$1");

            const borderedRun = xmlDoc.createElement("w:r");
            const borderedProps = xmlDoc.createElement("w:rPr");

            // Font size
            const fontSize = xmlDoc.createElement("w:sz");
            fontSize.setAttribute("w:val", "12");
            borderedProps.appendChild(fontSize);

            // Color
            const textColor = xmlDoc.createElement("w:color");
            textColor.setAttribute("w:val", "1f4e79");
            borderedProps.appendChild(textColor);

            // Border
            const textBorder = xmlDoc.createElement("w:bdr");
            textBorder.setAttribute("w:val", "single");
            textBorder.setAttribute("w:sz", "4");
            textBorder.setAttribute("w:space", "1");
            textBorder.setAttribute("w:color", "1f4e79");
            borderedProps.appendChild(textBorder);

            borderedRun.appendChild(borderedProps);

            const borderedText = xmlDoc.createElement("w:t");
            borderedText.textContent = day;
            borderedRun.appendChild(borderedText);

            newRuns.push(borderedRun);
          } else if (part === "\n") {
            // Adaugă line break pentru newline
            const breakRun = xmlDoc.createElement("w:r");
            const lineBreak = xmlDoc.createElement("w:br");
            breakRun.appendChild(lineBreak);
            newRuns.push(breakRun);
          } else if (part.trim() !== "") {
            // Partea normală
            const normalRun = xmlDoc.createElement("w:r");
            const normalProps = xmlDoc.createElement("w:rPr");

            // Font size
            const fontSize = xmlDoc.createElement("w:sz");
            fontSize.setAttribute("w:val", "12");
            normalProps.appendChild(fontSize);

            // Color
            const textColor = xmlDoc.createElement("w:color");
            textColor.setAttribute("w:val", "1f4e79");
            normalProps.appendChild(textColor);

            normalRun.appendChild(normalProps);

            const normalText = xmlDoc.createElement("w:t");
            normalText.textContent = part;
            normalRun.appendChild(normalText);

            newRuns.push(normalRun);
          }
        });

        // Inserez noile run-uri înainte de run-ul original
        newRuns.forEach((newRun) => {
          paragraph.insertBefore(newRun, parentRun);
        });

        // Șterge run-ul original
        paragraph.removeChild(parentRun);
      }
    }

    // Serializează XML-ul modificat înapoi într-un string
    documentXml = serializer.serializeToString(xmlDoc);

    // Actualizează fișierul în arhiva ZIP
    zip.file(xmlPath, documentXml);

    return zip;
  }
  const getIndex = (materieId) => {
    // Găsește materia cu "Purtare" în nume și o pune ultima (poziția 22)
    const materie = materii?.find((m) => m.id === materieId);

    if (
      materie?.numeMaterie?.includes("Purtare") &&
      ciclu(
        clase?.find((c) => c.id === classData.id),
        true
      ) === "liceu"
    )
      return 29;
    else if (
      (materie?.numeMaterie?.includes("Purtare") &&
        ciclu(
          clase?.find((c) => c.id === classData.id),
          true
        ) === "gimnaziu") ||
      ciclu(
        clase?.find((c) => c.id === classData.id),
        true
      ) === "primar"
    ) {
      return 22; // Forțează poziția 22 pentru materia cu "Purtare"
    }
    if (
      materie?.numeMaterie?.includes("Purtare") &&
      ciclu(
        clase?.find((c) => c.id === classData.id),
        true
      ) === "preg"
    ) {
      return 11; // Forțează poziția 22 pentru materia cu "Purtare"
    }
    return classData?.materii?.findIndex((m) => m.materie === materieId);
  };

  async function generateCoperta() {
    let cnt = 0;
    const templateArrayBuffer = await fetchTemplateCoperta();
    const zip = new PizZip(templateArrayBuffer);

    const templateDoc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });

    // Primul pas: extrage toate combinațiile materie-profesor valide din note
    // COMENTAT: Nu mai folosim profesorii din note, doar cei din materiile combinate
    /*
    const listOfProfesoriFromNotes = allNotes
      .sort((a, b) => getIndex(a.materieId) - getIndex(b.materieId))
      .reduce((acc, nota) => {
        if (
          (profesori?.find(
            (p) =>
              p.id === (nota.authorId || nota.author) ||
              p.displayName == (nota.authorId || nota.author)
          )?.type === "admin" ||
            (nota.authorId || nota.author) === classData?.diriginte) &&
          !materiiCombinate?.find(
            (m) =>
              m.materie === nota.materieId &&
              m.profesori?.find(
                (a) =>
                  a ==
                  profesori?.find(
                    (p) =>
                      p.id === (nota.authorId || nota.author) ||
                      p.displayName == (nota.authorId || nota.author)
                  )?.id
              )
          )
        )
          return acc;
        if (
          !profesori?.find((p) => p.id === nota.authorId) ||
          acc?.find(
            (c) =>
              c.materie ===
                materii?.find((m) => m.id === nota.materieId).numeMaterie &&
              c.profesor ===
                (profesori?.find((p) => p.id === nota.authorId)
                  ? profesori
                      ?.find((p) => p.id === nota.authorId)
                      .numeDeFamilie.toUpperCase() +
                    " " +
                    profesori
                      ?.find((p) => p.id === nota.authorId)
                      .prenume.toUpperCase()
                  : nota.author)
          )
        )
          return acc;
        else
          return [
            ...acc,
            {
              materie: materii?.find((m) => m.id === nota.materieId)
                .numeMaterie,
              profesor: profesori?.find((p) => p.id === nota.authorId)
                ? profesori
                    ?.find((p) => p.id === nota.authorId)
                    .numeDeFamilie.toUpperCase() +
                  " " +
                  profesori
                    ?.find((p) => p.id === nota.authorId)
                    .prenume.toUpperCase()
                : nota.author,
            },
          ];
      }, []);
    */

    // Extrage profesorii din materiile combinate (clasă + speciale)
    // Pentru clasa preg, arată toți profesorii, altfel doar cei care au dat note
    const isClassPreg =
      classData.anClasa === "Pregătitoare" || classData.identificator === "S";

    const materiiCombinate = combineToateMateriileElevilor();

    const listOfProfesori =
      materiiCombinate?.reduce((acc, materieObj) => {
        const materie = materii?.find((m) => m.id === materieObj.materie);
        if (!materie) return acc;

        materieObj.profesori?.forEach((profesorId) => {
          const profesor = profesori?.find((p) => p.id === profesorId);
          if (profesor) {
            // Dacă nu este clasa preg, verifică dacă profesorul a dat note
            if (!isClassPreg) {
              const hasGivenGrades = allNotes.some(
                (nota) =>
                  nota.materieId === materieObj.materie &&
                  (nota.authorId === profesorId ||
                    nota.author === profesorId ||
                    nota.author === profesor.displayName)
              );
              if (!hasGivenGrades) return; // Skip teacher if no grades given
            }

            const profesorName =
              profesor.numeDeFamilie.toUpperCase() +
              " " +
              profesor.prenume.toUpperCase();
            const existing = acc?.find(
              (item) =>
                item.materie === materie.numeMaterie &&
                item.profesor === profesorName
            );
            if (!existing) {
              acc.push({
                materie: materie.numeMaterie,
                profesor: profesorName,
              });
            }
          }
        });
        return acc;
      }, []) || [];

    // Al treilea pas: reunirea fără dubluri
    // COMENTAT: Nu mai combinăm listele, folosim doar profesorii din materiile combinate
    /*
    let listOfProfesori = [...listOfProfesoriFromNotes];
    listOfProfesoriFromClassData.forEach((item) => {
      const existing = listOfProfesori?.find(
        (existing) =>
          existing.materie === item.materie &&
          existing.profesor === item.profesor
      );
      if (!existing) {
        listOfProfesori.push(item);
      }
    });
    */

    // Al doilea pas: grupează profesorii pe materii
    const materiiGrupate = listOfProfesori.reduce((acc, item) => {
      if (!acc[item.materie]) {
        acc[item.materie] = [];
      }

      // Pentru materia Purtare, adaugă doar dirigintele/dirigintii
      if (item.materie.includes("Purtare")) {
        // Adaugă dirigintele principal
        if (classData?.diriginte) {
          const diriginteProf = profesori?.find(
            (p) => p.id === classData?.diriginte
          );
          if (diriginteProf) {
            const diriginteName =
              diriginteProf.numeDeFamilie.toUpperCase() +
              " " +
              diriginteProf.prenume.toUpperCase();
            if (!acc[item.materie].includes(diriginteName)) {
              acc[item.materie].push(diriginteName);
            }
          }
        }

        // Adaugă dirigintele secundar (dacă există)
        if (classData?.diriginte_step) {
          const diriginteStepProf = profesori?.find(
            (p) => p.id === classData?.diriginte_step
          );
          if (diriginteStepProf) {
            const diriginteStepName =
              diriginteStepProf.numeDeFamilie.toUpperCase() +
              " " +
              diriginteStepProf.prenume.toUpperCase();
            if (!acc[item.materie].includes(diriginteStepName)) {
              acc[item.materie].push(diriginteStepName);
            }
          }
        }
      } else {
        // Pentru celelalte materii, adaugă profesorul normal
        if (!acc[item.materie].includes(item.profesor)) {
          acc[item.materie].push(item.profesor);
        }
      }
      return acc;
    }, {});

    // Al treilea pas: creează structura pentru tabel
    cnt = 0;
    let profesoriTabel = Object.entries(materiiGrupate).reduce(
      (acc, [materie, profesori]) => {
        ++cnt;
        return {
          ...acc,
          [`tab_d${cnt}`]: materie,
          [`tab_p${cnt}`]: profesori.join("; "), // Toți profesorii separați prin virgulă
        };
      },
      {
        tab_d1: "",
        tab_p1: "",
        tab_d2: "",
        tab_p2: "",
        tab_d3: "",
        tab_p3: "",
        tab_d4: "",
        tab_p4: "",
        tab_d5: "",
        tab_p5: "",
        tab_d6: "",
        tab_p6: "",
        tab_d7: "",
        tab_p7: "",
        tab_d8: "",
        tab_p8: "",
        tab_d9: "",
        tab_p9: "",
        tab_d10: "",
        tab_p10: "",
        tab_d11: "",
        tab_p11: "",
        tab_d12: "",
        tab_p12: "",
        tab_d13: "",
        tab_p13: "",
        tab_d14: "",
        tab_p14: "",
        tab_d15: "",
        tab_p15: "",
        tab_d16: "",
        tab_p16: "",
        tab_d17: "",
        tab_p17: "",
        tab_d18: "",
        tab_p18: "",
        tab_d19: "",
        tab_p19: "",
        tab_d20: "",
        tab_p20: "",
        tab_d21: "",
        tab_p21: "",
        tab_d22: "",
        tab_p22: "",
        tab_d23: "",
        tab_p23: "",
        tab_d24: "",
        tab_p24: "",
        tab_d25: "",
        tab_p25: "",
        tab_d26: "",
        tab_p26: "",
        tab_d27: "",
        tab_p27: "",
        tab_d28: "",
        tab_p28: "",
        tab_d29: "",
        tab_p29: "",
        tab_d30: "",
        tab_p30: "",
        tab_d31: "",
        tab_p31: "",
        tab_d32: "",
        tab_p32: "",
        tab_d33: "",
        tab_p33: "",
        tab_d34: "",
        tab_p34: "",
        tab_d35: "",
        tab_p35: "",
        tab_d36: "",
        tab_p36: "",
        tab_d37: "",
        tab_p37: "",
        tab_d38: "",
        tab_p38: "",
      }
    );
    const invatamant = (() => {
      const an = classData.anClasa?.toUpperCase(); // ca să ne asigurăm că e caps

      if (!an) return "";

      if (["V", "VI", "VII", "VIII"].includes(an)) return "gimnazial";
      if (["IX", "X", "XI", "XII", "XIII"].includes(an)) return "liceal";
      if (["I", "II", "III", "IV", "PREGĂTITOARE"].includes(an))
        return "primar";

      return ""; // default sau alt mesaj
    })();
    console.log(
      "🟢 ELEVI VENIȚI:",
      eleviData.filter((e) => e.venitNou),
      { classData }
    );
    const resume = {
      invatamant,
      veniti: eleviData.filter(
        (e) =>
          e.venitNou ||
          e?.transferuri?.find((t) => {
            return (
              t.clasaVeche !== classData.id && t.clasaNoua === classData.id
            );
          })
      )?.length,
      inscrisi_start: (() => {
        const elevi = eleviData.filter(
          (e) =>
            !e.venitNou &&
            !e?.transferuri?.find((t) => {
              console.log(
                t,
                classData.id,
                t.clasaVeche !== classData.id,
                t.clasaNoua === classData.id
              );
              return (
                t.clasaVeche !== classData.id && t.clasaNoua === classData.id
              );
            })
        );

        console.log("🔵 ELEVI ÎNSCRIȘI START:", elevi);
        return elevi?.length;
      })(),
      plecati: (() => {
        const elevi = eleviData.filter(
          (e) => e.mutat == true || e.retras === true
        );
        console.log("🔴 ELEVI PLECAȚI:", elevi);
        return elevi?.length;
      })(),
      all: (() => {
        const elevi = eleviData.filter(
          (e) => e.mutat !== true && e.retras !== true
        );
        console.log("⚪ ELEVI ACTIVI:", elevi);
        return elevi?.length;
      })(),
      e1_med1: "",
      e1_med2: "",
      e1_medg: "",
      e2_med1: "",
      e2_med2: "",
      e2_medg: "",
      e3_med1: "",
      e3_med2: "",
      e3_medg: "",
      e4_med1: "",
      e4_med2: "",
      e4_medg: "",
      e5_med1: "",
      e5_med2: "",
      e5_medg: "",
      e6_med1: "",
      e6_med2: "",
      e6_medg: "",
      e7_med1: "",
      e7_med2: "",
      e7_medg: "",
      e8_med1: "",
      e8_med2: "",
      e8_medg: "",
      e9_med1: "",
      e9_med2: "",
      e9_medg: "",
      e10_med1: "",
      e10_med2: "",
      e10_medg: "",
      e11_med1: "",
      e11_med2: "",
      e11_medg: "",
      e12_med1: "",
      e12_med2: "",
      e12_medg: "",
      e13_med1: "",
      e13_med2: "",
      e13_medg: "",
      e14_med1: "",
      e14_med2: "",
      e14_medg: "",
      e15_med1: "",
      e15_med2: "",
      e15_medg: "",
      e16_med1: "",
      e16_med2: "",
      e16_medg: "",
      e17_med1: "",
      e17_med2: "",
      e17_medg: "",
      e18_med1: "",
      e18_med2: "",
      e18_medg: "",
      e19_med1: "",
      e19_med2: "",
      e19_medg: "",
      e20_med1: "",
      e20_med2: "",
      e20_medg: "",
      e21_med1: "",
      e21_med2: "",
      e21_medg: "",
      e22_med1: "",
      e22_med2: "",
      e22_medg: "",
      e23_med1: "",
      e23_med2: "",
      e23_medg: "",
      e24_med1: "",
      e24_med2: "",
      e24_medg: "",
      e25_med1: "",
      e25_med2: "",
      e25_medg: "",
      e26_med1: "",
      e26_med2: "",
      e26_medg: "",
      e27_med1: "",
      e27_med2: "",
      e27_medg: "",
      e28_med1: "",
      e28_med2: "",
      e28_medg: "",
      e29_med1: "",
      e29_med2: "",
      e29_medg: "",
      e30_med1: "",
      e30_med2: "",
      e30_medg: "",
      what_lead:
        invatamant === "primar"
          ? "ÎNVĂȚĂTOR / INSTITUTOR /PROFESOR PENTRU ÎNVĂȚĂMÂNT PRIMAR"
          : "DIRIGINTE",
      total_absente: eleviData.reduce(
        (acc, c) =>
          acc + gradesElevi[c.id].absente.absente_dupa_motivari?.length,
        0
      ),
      total_absente_nemot: eleviData.reduce(
        (acc, c) => acc + gradesElevi[c.id].absente.absente_nemotivate?.length,
        0
      ),
      ui: settings.numeInstitutie,
      loc: settings.loc,
      judet: settings.judet,
      clasa: renderClassName(clase?.find((c) => c.id === classData.id)),
      director: settings.director,
      dir: (() => {
        const dirigintePrincipal = profesori?.find(
          (p) => p.id === classData?.diriginte
        );
        const diriginteSecundar = profesori?.find(
          (p) => p.id === classData?.diriginte_step
        );

        let dirNames = [];
        if (dirigintePrincipal) {
          dirNames.push(
            dirigintePrincipal.numeDeFamilie.toUpperCase() +
              " " +
              dirigintePrincipal.prenume.toUpperCase()
          );
        }
        if (diriginteSecundar) {
          dirNames.push(
            diriginteSecundar.numeDeFamilie.toUpperCase() +
              " " +
              diriginteSecundar.prenume.toUpperCase()
          );
        }

        return dirNames.join("\n");
      })(),
      ...profesoriTabel,
      ...{
        m1: "",
        m2: "",
        m3: "",
        m4: "",
        m5: "",
        m6: "",
        m7: "",
        m8: "",
        m9: "",
        m10: "",
        m11: "",
        m12: "",
        m13: "",
        m14: "",
        m15: "",
        m16: "",
        m17: "",
        m18: "",
        m19: "",
        m20: "",
        m21: "",
        m22: "",
        m23: "",
        m24: "",
        m25: "",
        m26: "",
        m27: "",
        m28: "",
        m29: "",
        m30: "",
        m31: "",
        m32: "",
        m33: "",
        m34: "",
        m35: "",
        m36: "",
        m37: "",
        m38: "",
      },
    };
    templateDoc.render(resume);

    const generatedDoc = templateDoc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });
    const zipFromGeneratedDoc = new PizZip(await generatedDoc.arrayBuffer());

    // Modifică XML-ul documentului

    // Generează documentul final cu modificările aplicate
    const finalGeneratedDoc = zipFromGeneratedDoc.generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });

    // Salvează documentul final
    return finalGeneratedDoc;
  }

  async function generateFinal() {
    let cnt = 0;
    const templateArrayBuffer = await fetchTemplateFinal();
    const zip = new PizZip(templateArrayBuffer);

    const templateDoc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });
    let generatedObject = {};
    for (let e = 1; e <= 35; e++) {
      for (let m = 1; m <= 30; m++) {
        generatedObject[`e${e}_m${m}`] = "\n\n\n\n\n\n ";
        generatedObject[`e${e}_mc${m}`] = "\n\n\n\n";
        generatedObject[`e${e}_a${m}`] = "\n\n\n\n";
        generatedObject[`e${e}_ta`] = "\n\n\n\n";
        generatedObject[`e${e}_abs_n`] = "\n\n\n\n";
        generatedObject["e" + e + "_crt"] = "";
        generatedObject["e" + e + "_nf"] = "";
        generatedObject["e" + e + "_pr"] = "";
        generatedObject["e" + e + "_ta"] = "";
        generatedObject["e" + e + "_abs_n"] = "";
        generatedObject["e" + e + "_med1"] = "";
        generatedObject["e" + e + "_med2"] = "";
        generatedObject["e" + e + "_medg"] = "";
        generatedObject["e" + e + "_detalii"] = "";
        generatedObject["e" + e + "_nrmat"] = "";
        generatedObject["e" + e + "_fullname"] = "";
        generatedObject["e" + e + "_nastere"] = "";
        generatedObject["e" + e + "_mama"] = "";
        generatedObject["e" + e + "_tata"] = "";
        generatedObject["e" + e + "_dom_nr_telefon"] = "";
        generatedObject["e" + e + "_v"] = "";
        generatedObject["e" + e + "_p"] = "";
        generatedObject["e" + e + "_nrMatricol"] = "";
      }
    }
    let dateElevi = eleviData.reduce((acc, e) => {
      ++cnt;
      return {
        ...acc,
        ["e" + cnt + "_nf"]: e.numeDeFamilie,
        ["e" + cnt + "_pr"]: e.prenume + " " + (e.initiala || ""),
        ["e" + cnt + "_nrmat"]: e.numarMatricol,
        ["e" + cnt + "_crt"]: cnt,
        ["e" + cnt + "_fullname"]:
          e.numeDeFamilie +
          " " +
          e.initiala +
          " " +
          e.prenume.replace(/-/g, " "),
        ["e" + cnt + "_nastere"]: extractDateFromCNP(e.cnp),
        ["e" + cnt + "_mama"]: e.mama || "",
        ["e" + cnt + "_tata"]: e.tata || "",
        ["e" + cnt + "_dom_nr_telefon"]:
          (e.domiciliu || "") + ", " + (e.numarTelefon || ""),
        ["e" + cnt + "_ta"]:
          gradesElevi[e.id].absente.absente_dupa_motivari?.length,
        ["e" + cnt + "_abs_n"]:
          gradesElevi[e.id].absente.absente_nemotivate?.length,

        ["e" + cnt + "_detalii"]: e.detalii || "",
      };
    }, {});
    cnt = 0;

    // Primul pas: extrage profesorii din note
    // COMENTAT: Nu mai folosim profesorii din note, doar cei din materiile combinate
    /*
    const listOfProfesoriFromNotes = allNotes
      .sort((a, b) => getIndex(a.materieId) - getIndex(b.materieId))
      .reduce((acc, nota) => {
        if (
          (profesori?.find(
            (p) =>
              p.id === (nota.authorId || nota.author) ||
              p.displayName == (nota.authorId || nota.author)
          )?.type === "admin" ||
            (nota.authorId || nota.author) === classData?.diriginte) &&
          !materiiCombinate?.find(
            (m) =>
              m.materie === nota.materieId &&
              m.profesori?.find(
                (a) =>
                  a ==
                  profesori?.find(
                    (p) =>
                      p.id === (nota.authorId || nota.author) ||
                      p.displayName == (nota.authorId || nota.author)
                  )?.id
              )
          )
        )
          return acc;
        if (
          !profesori?.find((p) => p.id === nota.authorId) ||
          acc?.find(
            (c) =>
              c.materie ===
                materii?.find((m) => m.id === nota.materieId).numeMaterie &&
              c.profesor ===
                (profesori?.find((p) => p.id === nota.authorId)
                  ? profesori
                      ?.find((p) => p.id === nota.authorId)
                      .numeDeFamilie.toUpperCase() +
                    " " +
                    profesori
                      ?.find((p) => p.id === nota.authorId)
                      .prenume.toUpperCase()
                  : nota.author)
          )
        )
          return acc;
        else
          return [
            ...acc,
            {
              materie: materii?.find((m) => m.id === nota.materieId)
                .numeMaterie,
              profesor: profesori?.find((p) => p.id === nota.authorId)
                ? profesori
                    ?.find((p) => p.id === nota.authorId)
                    .numeDeFamilie.toUpperCase() +
                  " " +
                  profesori
                    ?.find((p) => p.id === nota.authorId)
                    .prenume.toUpperCase()
                : nota.author,
            },
          ];
      }, []);
    */

    // Extrage profesorii din materiile combinate (clasă + speciale)
    // Pentru clasa preg, arată toți profesorii, altfel doar cei care au dat note
    const isClassPreg =
      classData.anClasa === "Pregătitoare" || classData.identificator === "S";

    const materiiCombinate = combineToateMateriileElevilor();

    const listOfProfesori =
      materiiCombinate?.reduce((acc, materieObj) => {
        const materie = materii?.find((m) => m.id === materieObj.materie);
        if (!materie) return acc;

        materieObj.profesori?.forEach((profesorId) => {
          const profesor = profesori?.find((p) => p.id === profesorId);
          if (profesor) {
            // Dacă nu este clasa preg, verifică dacă profesorul a dat note
            if (!isClassPreg) {
              const hasGivenGrades = allNotes.some(
                (nota) =>
                  nota.tip === "nota" &&
                  nota.materieId === materieObj.materie &&
                  (nota.authorId === profesorId ||
                    nota.author === profesorId ||
                    nota.author === profesor.displayName)
              );
              if (!hasGivenGrades) return; // Skip teacher if no grades given
            }

            const profesorName =
              profesor.numeDeFamilie.toUpperCase() +
              " " +
              profesor.prenume.toUpperCase();
            const existing = acc?.find(
              (item) =>
                item.materie === materie.numeMaterie &&
                item.profesor === profesorName
            );
            if (!existing) {
              acc.push({
                materie: materie.numeMaterie,
                profesor: profesorName,
              });
            }
          }
        });
        return acc;
      }, []) || [];

    // Al treilea pas: combină listele fără duplicate
    // COMENTAT: Nu mai combinăm listele, folosim doar profesorii din materiile combinate
    /*
    let listOfProfesori = [...listOfProfesoriFromNotes];
    listOfProfesoriFromClassData.forEach((item) => {
      const existing = listOfProfesori?.find(
        (existing) =>
          existing.materie === item.materie &&
          existing.profesor === item.profesor
      );
      if (!existing) {
        listOfProfesori.push(item);
      }
    });
    */

    // Al patrulea pas: grupează materiile pe profesori
    const profesoriGrupati = listOfProfesori.reduce((acc, item) => {
      // Pentru materia Purtare, asociază doar cu dirigintele/dirigintii
      if (item.materie.includes("Purtare")) {
        // Asociază cu dirigintele principal
        if (classData?.diriginte) {
          const diriginteProf = profesori?.find(
            (p) => p.id === classData?.diriginte
          );
          if (diriginteProf) {
            const diriginteName =
              diriginteProf.numeDeFamilie.toUpperCase() +
              " " +
              diriginteProf.prenume.toUpperCase();
            if (!acc[diriginteName]) {
              acc[diriginteName] = [];
            }
            if (!acc[diriginteName].includes(item.materie)) {
              acc[diriginteName].push(item.materie);
            }
          }
        }

        // Asociază cu dirigintele secundar (dacă există)
        if (classData?.diriginte_step) {
          const diriginteStepProf = profesori?.find(
            (p) => p.id === classData?.diriginte_step
          );
          if (diriginteStepProf) {
            const diriginteStepName =
              diriginteStepProf.numeDeFamilie.toUpperCase() +
              " " +
              diriginteStepProf.prenume.toUpperCase();
            if (!acc[diriginteStepName]) {
              acc[diriginteStepName] = [];
            }
            if (!acc[diriginteStepName].includes(item.materie)) {
              acc[diriginteStepName].push(item.materie);
            }
          }
        }
      } else {
        // Pentru celelalte materii, asociază cu profesorul normal
        if (!acc[item.profesor]) {
          acc[item.profesor] = [];
        }
        if (!acc[item.profesor].includes(item.materie)) {
          acc[item.profesor].push(item.materie);
        }
      }
      return acc;
    }, {});

    // Al cincilea pas: creează structura pentru tabel, sortată alfabetic după profesori
    let profesoriTabel = Object.entries(profesoriGrupati)
      .sort(([profesorA], [profesorB]) =>
        profesorA.localeCompare(profesorB, "ro")
      )
      .reduce(
        (acc, [profesor, materii]) => {
          ++cnt;
          return {
            ...acc,
            [`tab_d${cnt}`]: materii.sort().join("; "), // Toate materiile sortate alfabetic
            [`tab_p${cnt}`]: profesor,
          };
        },
        {
          tab_d1: "",
          tab_p1: "",
          tab_d2: "",
          tab_p2: "",
          tab_d3: "",
          tab_p3: "",
          tab_d4: "",
          tab_p4: "",
          tab_d5: "",
          tab_p5: "",
          tab_d6: "",
          tab_p6: "",
          tab_d7: "",
          tab_p7: "",
          tab_d8: "",
          tab_p8: "",
          tab_d9: "",
          tab_p9: "",
          tab_d10: "",
          tab_p10: "",
          tab_d11: "",
          tab_p11: "",
          tab_d12: "",
          tab_p12: "",
          tab_d13: "",
          tab_p13: "",
          tab_d14: "",
          tab_p14: "",
          tab_d15: "",
          tab_p15: "",
          tab_d16: "",
          tab_p16: "",
          tab_d17: "",
          tab_p17: "",
          tab_d18: "",
          tab_p18: "",
          tab_d19: "",
          tab_p19: "",
          tab_d20: "",
          tab_p20: "",
          tab_d21: "",
          tab_p21: "",
          tab_d22: "",
          tab_p22: "",
          tab_d23: "",
          tab_p23: "",
          tab_d24: "",
          tab_p24: "",
          tab_d25: "",
          tab_p25: "",
          tab_d26: "",
          tab_p26: "",
          tab_d27: "",
          tab_p27: "",
          tab_d28: "",
          tab_p28: "",
          tab_d29: "",
          tab_p29: "",
          tab_d30: "",
          tab_p30: "",
          tab_d31: "",
          tab_p31: "",
          tab_d32: "",
          tab_p32: "",
          tab_d33: "",
          tab_p33: "",
          tab_d34: "",
          tab_p34: "",
          tab_d35: "",
          tab_p35: "",
          tab_d36: "",
          tab_p36: "",
          tab_d37: "",
          tab_p37: "",
          tab_d38: "",
          tab_p38: "",
          tab_d39: "",
          tab_p39: "",
          tab_d40: "",
          tab_p40: "",
          tab_d41: "",
          tab_p41: "",
          tab_d42: "",
          tab_p42: "",
          tab_d43: "",
          tab_p43: "",
          tab_d44: "",
          tab_p44: "",
          tab_d45: "",
          tab_p45: "",
          tab_d46: "",
          tab_p46: "",
          tab_d47: "",
          tab_p47: "",
          tab_d48: "",
          tab_p48: "",
          tab_d49: "",
          tab_p49: "",
          tab_d50: "",
          tab_p50: "",
        }
      );

    const resume = {
      veniti: eleviData.filter(
        (e) =>
          e.venitNou ||
          e?.transferuri?.find((t) => {
            return (
              t.clasaVeche !== classData.id && t.clasaNoua === classData.id
            );
          })
      )?.length,
      inscrisi_start: (() => {
        const elevi = eleviData.filter(
          (e) =>
            !e.venitNou &&
            !e?.transferuri?.find((t) => {
              return (
                t.clasaVeche !== classData.id && t.clasaNoua === classData.id
              );
            })
        );

        return elevi?.length;
      })(),
      plecati: (() => {
        const elevi = eleviData.filter(
          (e) => e.mutat == true || e.retras === true
        );

        return elevi?.length;
      })(),
      all: (() => {
        const elevi = eleviData.filter(
          (e) => e.mutat !== true && e.retras !== true
        );
        console.log("⚪ ELEVI ACTIVI:", elevi);
        return elevi?.length;
      })(),
      tutor:
        ciclu(clase?.find((c) => c.id === classData.id)) == "primar"
          ? "ÎNVĂȚĂTOR / INSTITUTOR /PROFESOR PENTRU ÎNVĂȚĂMÂNT PRIMAR"
          : "Diriginte",

      e1_med1: "",
      e1_med2: "",
      e1_medg: "",
      e2_med1: "",
      e2_med2: "",
      e2_medg: "",
      e3_med1: "",
      e3_med2: "",
      e3_medg: "",
      e4_med1: "",
      e4_med2: "",
      e4_medg: "",
      e5_med1: "",
      e5_med2: "",
      e5_medg: "",
      e6_med1: "",
      e6_med2: "",
      e6_medg: "",
      e7_med1: "",
      e7_med2: "",
      e7_medg: "",
      e8_med1: "",
      e8_med2: "",
      e8_medg: "",
      e9_med1: "",
      e9_med2: "",
      e9_medg: "",
      e10_med1: "",
      e10_med2: "",
      e10_medg: "",
      e11_med1: "",
      e11_med2: "",
      e11_medg: "",
      e12_med1: "",
      e12_med2: "",
      e12_medg: "",
      e13_med1: "",
      e13_med2: "",
      e13_medg: "",
      e14_med1: "",
      e14_med2: "",
      e14_medg: "",
      e15_med1: "",
      e15_med2: "",
      e15_medg: "",
      e16_med1: "",
      e16_med2: "",
      e16_medg: "",
      e17_med1: "",
      e17_med2: "",
      e17_medg: "",
      e18_med1: "",
      e18_med2: "",
      e18_medg: "",
      e19_med1: "",
      e19_med2: "",
      e19_medg: "",
      e20_med1: "",
      e20_med2: "",
      e20_medg: "",
      e21_med1: "",
      e21_med2: "",
      e21_medg: "",
      e22_med1: "",
      e22_med2: "",
      e22_medg: "",
      e23_med1: "",
      e23_med2: "",
      e23_medg: "",
      e24_med1: "",
      e24_med2: "",
      e24_medg: "",
      e25_med1: "",
      e25_med2: "",
      e25_medg: "",
      e26_med1: "",
      e26_med2: "",
      e26_medg: "",
      e27_med1: "",
      e27_med2: "",
      e27_medg: "",
      e28_med1: "",
      e28_med2: "",
      e28_medg: "",
      e29_med1: "",
      e29_med2: "",
      e29_medg: "",
      e30_med1: "",
      e30_med2: "",
      e30_medg: "",
      file:
        1 + parseInt(eleviData?.length / 3) + (eleviData?.length % 3 > 0) + 2,
      total_absente: eleviData.reduce(
        (acc, c) =>
          acc + gradesElevi[c.id].absente.absente_dupa_motivari?.length,
        0
      ),
      total_absente_nemot: eleviData.reduce(
        (acc, c) => acc + gradesElevi[c.id].absente.absente_nemotivate?.length,
        0
      ),
      ui: settings.numeInstitutie,
      loc: settings.loc,
      judet: settings.judet,
      secretar: settings.secretar,
      clasa: renderClassName(clase?.find((c) => c.id === classData.id)),
      director: settings.director,

      promovati_final: eleviData.filter(
        (e) =>
          e.stareaLaFinalulAnului &&
          e.stareaLaFinalulAnului.toLowerCase().includes("promovat") &&
          e.mutat !== true &&
          e.retras !== true
      ).length,
      promovati: eleviData.filter(
        (e) =>
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor.toLowerCase().includes("promovat") &&
          e.mutat !== true &&
          e.retras !== true
      ).length,

      // Console log pentru elevii nepromovati

      corigenti_o_disciplina: eleviData.filter((e) => {
        const hasCorigentStatus =
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor.toLowerCase().includes("corigent") &&
          e.mutat !== true &&
          e.retras !== true;
        if (!hasCorigentStatus) return false;

        const materiiCuProbleme =
          classData?.materii?.reduce((arr, m) => {
            if (
              !gradesElevi[e.id]?.note?.find((n) => n.materieId === m.materie)
            )
              return arr;

            const medieMeta = calculeaza_medie_materie(
              gradesElevi[e.id]?.note || [],
              materii?.find((ma) => ma.id === m.materie),
              scutiri[e.id]
            );

            if (
              gradesElevi[e.id]?.note
                .filter((n) => n.materieId === m.materie)
                .filter((n) => n.tip === "corigenta").length > 0
            )
              return [
                ...arr,
                {
                  materieId: m.materie,
                  tip: "sex",
                  media: gradesElevi[e.id]?.note
                    .filter((n) => n.materieId === m.materie)
                    .filter((n) => n.tip === "corigenta").corigenta,
                },
              ];

            if (medieMeta.medie !== 0) {
              if (medieMeta.medie < 5 || medieMeta.medie === "I") {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "corigent",
                    media: medieMeta.medie,
                  },
                ];
              } else if (!medieMeta.inchis) {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "neinchis",
                    media: medieMeta.medie,
                  },
                ];
              }
            }
            return arr;
          }, []) || [];
        console.log("pfff", e, { materiiCuProbleme });
        return materiiCuProbleme?.length === 1;
      }).length,
      corigenti_doua_discipline: eleviData.filter((e) => {
        const hasCorigentStatus =
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor.toLowerCase().includes("corigent") &&
          e.mutat !== true &&
          e.retras !== true;
        if (!hasCorigentStatus) return false;

        const materiiCuProbleme =
          classData?.materii?.reduce((arr, m) => {
            if (
              !gradesElevi[e.id]?.note?.find((n) => n.materieId === m.materie)
            )
              return arr;
            if (
              gradesElevi[e.id]?.note
                .filter((n) => n.materieId === m.materie)
                .filter((n) => n.tip === "corigenta").length > 0
            )
              return [
                ...arr,
                {
                  materieId: m.materie,
                  tip: "sex",
                  media: gradesElevi[e.id]?.note
                    .filter((n) => n.materieId === m.materie)
                    .filter((n) => n.tip === "corigenta").corigenta,
                },
              ];
            const medieMeta = calculeaza_medie_materie(
              gradesElevi[e.id]?.note || [],
              materii?.find((ma) => ma.id === m.materie),
              scutiri[e.id]
            );

            if (medieMeta.medie !== 0) {
              if (medieMeta.medie < 5 || medieMeta.medie === "I") {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "corigent",
                    media: medieMeta.medie,
                  },
                ];
              } else if (!medieMeta.inchis) {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "neinchis",
                    media: medieMeta.medie,
                  },
                ];
              }
            }
            return arr;
          }, []) || [];
        console.log({ materiiCuProbleme });
        return materiiCuProbleme?.length === 2;
      }).length,
      corigenti: (() => {
        const elevi = eleviData.filter(
          (e) =>
            e.stareaLaIncheiereaCursurilor &&
            e.stareaLaIncheiereaCursurilor.toLowerCase().includes("corigent") &&
            e.mutat !== true &&
            e.retras !== true
        );
        console.log("🟡 ELEVI CORIGENȚI:", elevi);
        return elevi?.length;
      })(),
      repetenti: eleviData.filter(
        (e) =>
          e.stareaLaFinalulAnului &&
          e.stareaLaFinalulAnului.toLowerCase().includes("repetent") &&
          e.mutat !== true &&
          e.retras !== true
      ).length,
      amanat_o_disciplina: eleviData.filter((e) => {
        const hasAmanatStatus =
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor.toLowerCase().includes("amanat") &&
          e.mutat !== true &&
          e.retras !== true;
        if (!hasAmanatStatus) return false;

        const materiiCuProbleme =
          classData?.materii?.reduce((arr, m) => {
            if (
              !gradesElevi[e.id]?.note?.find((n) => n.materieId === m.materie)
            )
              return arr;

            const medieMeta = calculeaza_medie_materie(
              gradesElevi[e.id]?.note || [],
              materii?.find((ma) => ma.id === m.materie),
              scutiri[e.id]
            );

            if (medieMeta.medie !== 0) {
              if (medieMeta.medie < 5 || medieMeta.medie === "I") {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "corigent",
                    media: medieMeta.medie,
                  },
                ];
              } else if (!medieMeta.inchis) {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "neinchis",
                    media: medieMeta.medie,
                  },
                ];
              }
            }
            return arr;
          }, []) || [];

        return materiiCuProbleme?.length === 1;
      }).length,
      amanat_mai_multe_discipline: eleviData.filter((e) => {
        const hasAmanatStatus =
          e.stareaLaIncheiereaCursurilor &&
          e.stareaLaIncheiereaCursurilor.toLowerCase().includes("amanat") &&
          e.mutat !== true &&
          e.retras !== true;
        if (!hasAmanatStatus) return false;

        const materiiCuProbleme =
          classData?.materii?.reduce((arr, m) => {
            if (
              !gradesElevi[e.id]?.note?.find((n) => n.materieId === m.materie)
            )
              return arr;

            const medieMeta = calculeaza_medie_materie(
              gradesElevi[e.id]?.note || [],
              materii?.find((ma) => ma.id === m.materie),
              scutiri[e.id]
            );

            if (medieMeta.medie !== 0) {
              if (medieMeta.medie < 5 || medieMeta.medie === "I") {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "corigent",
                    media: medieMeta.medie,
                  },
                ];
              } else if (!medieMeta.inchis) {
                return [
                  ...arr,
                  {
                    materieId: m.materie,
                    tip: "neinchis",
                    media: medieMeta.medie,
                  },
                ];
              }
            }
            return arr;
          }, []) || [];

        return materiiCuProbleme?.length >= 2;
      }).length,
      dir: (() => {
        const dirigintePrincipal = profesori?.find(
          (p) => p.id === classData?.diriginte
        );
        const diriginteSecundar = profesori?.find(
          (p) => p.id === classData?.diriginte_step
        );

        let dirNames = [];
        if (dirigintePrincipal) {
          dirNames.push(
            dirigintePrincipal.numeDeFamilie.toUpperCase() +
              " " +
              dirigintePrincipal.prenume.toUpperCase()
          );
        }
        if (diriginteSecundar) {
          dirNames.push(
            diriginteSecundar.numeDeFamilie.toUpperCase() +
              " " +
              diriginteSecundar.prenume.toUpperCase()
          );
        }

        return dirNames.join("\n");
      })(),
      pozitii: Math.ceil(eleviData?.length / 3) * 3,
      comp: eleviData?.length,
      necomp: Math.ceil(eleviData?.length / 3) * 3 - eleviData?.length,
      ...profesoriTabel,
      ...generatedObject,
      ...{
        m1: "",
        m2: "",
        m3: "",
        m4: "",
        m5: "",
        m6: "",
        m7: "",
        m8: "",
        m9: "",
        m10: "",
        m11: "",
        m12: "",
        m13: "",
        m14: "",
        m15: "",
        m16: "",
        m17: "",
        m18: "",
        m19: "",
        m20: "",
        m21: "",
        m22: "",
        m23: "",
        m24: "",
        m25: "",
        m26: "",
        m27: "",
        m28: "",
        m29: "",
        m30: "",
        m31: "",
        m32: "",
        m33: "",
        m34: "",
        m35: "",
        m36: "",

        m37: "",
        m38: "",

        ...dateElevi,
      },
    };
    templateDoc.render(resume);

    const generatedDoc = templateDoc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });
    const zipFromGeneratedDoc = new PizZip(await generatedDoc.arrayBuffer());

    // Modifică XML-ul documentului

    // Generează documentul final cu modificările aplicate
    const finalGeneratedDoc = zipFromGeneratedDoc.generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      compression: "DEFLATE",
    });

    // Salvează documentul final
    return finalGeneratedDoc;
  }
  const generateDocument = useCallback(async () => {
    if (eleviData?.length === 0) return 0;

    let coperta = await generateCoperta();
    let final = await generateFinal();
    let array = [coperta];
    for await (let chunkElevi of groupArrayIntoChunks(eleviData)) {
      let doc = await generateWordChunck(chunkElevi);
      array = [...array, doc];
    }
    array = [...array, final];
    if (array.length > 1) await mergeWordDocuments(array);

    // } catch (error) {
    //   // console.error("Error generating document:", error.message);
    // }
  }, [eleviData]);

  const styleD = () => {
    if (onlyWidth < 700) return "auto";
    if (onlyWidth < 1000) return "auto auto ";
    if (onlyWidth < 1200) return "auto auto auto ";
    return "auto auto auto  ";
  };

  const fetchData = async () => {
    let newArray = [];
    let scutiriElevi = {};
    let note = {};
    let NotePrint = [];

    for (let elev of classData?.elevi || []) {
      const docs = await getDataDoc("eleviDocumente", elev.id);

      scutiriElevi[elev.id] = docs?.docsElev.filter(
        (doc) => doc.tip === "scutire" || doc.tip === "bilet"
      );
    }
    let allNotes = [];
    for await (let elev of classData?.elevi || []) {
      let obj = {};
      const notes = await getDataDoc("catalog", elev.id);
      if (elev.mutat === true) {
        note[elev.id] = {
          note: elev.gradesFrozen,
          absente: motiveazaAbsente(
            elev.gradesFrozen,
            elev?.docsFrozen?.docsElev
          ),
        };
      } else
        note[elev.id] = {
          note: notes?.note,
          absente: motiveazaAbsente(notes?.note, scutiriElevi[elev.id]),
        };
      allNotes = [
        ...allNotes,
        ...(notes?.note || []),
        ...(motiveazaAbsente(notes?.note, scutiriElevi[elev.id])
          .absente_dupa_motivari || []),
      ];
      let dataE = await getDataDoc("elevi", elev.id);
      newArray.push({
        ...elev,
        ...dataE,
        key: elev.id,
        nume: elev.numeDeFamilie + " " + elev.initiala + " " + elev.prenume,
      });
    }

    setNotePrint(NotePrint);

    setScutiri(scutiriElevi);

    setEleviData([
      ...newArray
        .filter(
          (a) =>
            !(
              a.venitNou ||
              (a.transferuri?.length > 0 && !a.mutat && !a.retras)
            )
        )
        .sort((a, b) => a.nume.localeCompare(b.nume, "ro")),
      ...newArray
        .filter(
          (a) =>
            a.venitNou || (a.transferuri?.length > 0 && !a.mutat && !a.retras)
        )
        .sort((a, b) => a.nume.localeCompare(b.nume, "ro")),
    ]);

    setGradesElevi(note);
    setAllNotes(allNotes);
  };

  const decideNumber = () => {
    if (onlyWidth < 700) return 1;
    if (onlyWidth < 900) return 2;
    if (onlyWidth < 1500) return 3;

    return 4;
  };

  const formatDate = (today, tip) => {
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    // Conversie cifre romane pentru luna
    const romanNumerals = [
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
      "XI",
      "XII",
    ];
    const romanMonth = romanNumerals[mm];

    if (dd < 10) dd = "0" + dd;
    if (tip === "nota") return dd + romanMonth;
    return dd + "." + romanMonth;
  };

  const formatAbsencesGrouped = (absences) => {
    // Sort absences by date
    const sortedAbsences = [...absences].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    // Group by month
    const groupedByMonth = {};
    sortedAbsences.forEach((absence) => {
      const date = new Date(absence.date);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const romanNumerals = [
        "",
        " I",
        " II",
        " III",
        " IV",
        " V",
        " VI",
        " VII",
        " VIII",
        " IX",
        " X",
        " XI",
        " XII",
      ];
      const romanMonth = romanNumerals[month];

      if (!groupedByMonth[romanMonth]) {
        groupedByMonth[romanMonth] = [];
      }

      groupedByMonth[romanMonth].push({
        day: day,
        motivated: absence.motivat,
      });
    });

    // Format the result - each month on new line
    const results = [];
    Object.keys(groupedByMonth).forEach((month) => {
      const days = groupedByMonth[month];
      const dayStrings = days.map((d) =>
        d.motivated ? `xyzg${d.day}` : d.day.toString()
      );
      results.push(` ${month}: ${dayStrings.join("; ")}`);
    });

    return results.join("\n");
  };
  useEffect(() => {
    fetchData();
  }, [classData]);
  useEffect(() => {
    let array = [];
    for (let elev of classData?.elevi || []) {
      const unsub = onSnapshot(doc(db, "catalog", elev.id), (doc) => {
        fetchData();
      });
      const unsub3 = onSnapshot(doc(db, "elevi", elev.id), (doc) => {
        fetchData();
      });
      const unsub2 = onSnapshot(doc(db, "eleviDocumente", elev.id), (doc) => {
        fetchData();
      });
      array.push(unsub);
      array.push(unsub2);
      array.push(unsub3);
    }
  }, []);

  const fetchProfiles = async () => {
    let profileElevi = {};
    for await (let elev of classData?.elevi || []) {
      const profilElev = await getDataDoc("elevi", elev.id);
      profileElevi[elev.id] = profilElev;
    }
    setProfileElevi(profileElevi);
  };
  useEffect(() => {
    if (display === true) {
      fetchProfiles();
    }
  }, [display]);

  const materii = useSelector((state) => state.materii);
  const handlePrint = useReactToPrint({
    content: () => print.current,
  });

  // Auto-export pentru modul export și export-zip
  useEffect(() => {
    if (
      (mode === "export" || mode === "export-zip") &&
      !loading &&
      eleviData?.length > 0
    ) {
      const autoExport = async () => {
        setLoading(true);
        let res = await generateDocument();
        if (res === 0) await generateDocument();
        setLoading(false);
      };
      autoExport();
    }
  }, [eleviData, mode, loading, generateDocument]);

  return (
    <>
      {mode === "export" || mode === "export-zip" ? (
        loading === true ? (
          <>
            <h3>Catalogul se generează...</h3>
            <p>Se încarcă, durează aproximativ 1 minut</p>
          </>
        ) : eleviData?.length > 0 ? (
          <>
            <h3>Catalogul a fost generat</h3>
            <p>
              {mode === "export-zip"
                ? "Adăugat în ZIP!"
                : "Descărcarea a început!"}
            </p>
          </>
        ) : (
          <h3>Se pregătesc datele...</h3>
        )
      ) : (
        <>
          <h3>Catalogul este gata</h3>
          {loading === true && <p>Se încarcă, durează aproximativ 1 minut</p>}
          {loading === false && eleviData?.length > 0 && (
            <Button
              onClick={async () => {
                setLoading(true);
                let res = await generateDocument();
                if (res === 0) await generateDocument();
                setLoading(false);
              }}
            >
              Print
            </Button>
          )}
        </>
      )}
    </>
  );
}

export default Catalog;
